/**
 * event handler to use with "beforeunload" event type.
 * displays browser specific confirmation window with
 * "confirm/cancel" buttons that either cancel redirection,
 * or let it go through. Custom text not allowed.
 * Always remove the listener after use!
 *
 * NB! "onbeforeunload" from this composable replaces
 * "window.onbeforeUnload" from monolith. After removing
 * the event listener, make sure page is reloaded to
 * re-insert "window.onbeforeUnload" event listener in monolith
 */

const beforeUnloadListener = (event: BeforeUnloadEvent) => {
	event.preventDefault();
	return (event.returnValue = '');
};

export const useBeforeUnloadEventHandler = () => {
	const addBeforeUnloadEventListener = () => {
		window.addEventListener('beforeunload', beforeUnloadListener);
	};

	const removeBeforeUnloadEventListener = () => {
		window.removeEventListener('beforeunload', beforeUnloadListener);
	};

	return {
		addBeforeUnloadEventListener,
		removeBeforeUnloadEventListener,
	};
};
